module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/passthrough.js
// module id = 347
// module chunks = 0